/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Preview_Activity_ConnectedInputs */

const en_landing_preview_activity_connected = /** @type {(inputs: Landing_Preview_Activity_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`connected a buy-side agent`)
};

/**
* | output |
* | --- |
* | "connected a buy-side agent" |
*
* @param {Landing_Preview_Activity_ConnectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_preview_activity_connected = /** @type {((inputs?: Landing_Preview_Activity_ConnectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Preview_Activity_ConnectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_preview_activity_connected(inputs)
});